import { AccessComponentEnum, AccessLevelEnum } from 'graphql-common';
import { APP_URLS } from 'constants/urls';
import { NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';
import { NavItemArgs } from './types';

export default function getDashboardNavItem(args: NavItemArgs) {
  const { t, pathname, getUserAccessByComponent } = args;
  const isTasksAvailable =
    getUserAccessByComponent(AccessComponentEnum.TasksManagement) !==
    AccessLevelEnum.LimitedRead;
  return {
    id: 'dashboard',
    title: t('dashboard'),
    leftIcon: Icons.dashboard,
    to: APP_URLS.dashboard.overview.getPathWithQuery(),
    type: NavItemTypeEnum.Primary,
    predictorFnVisible: () => isTasksAvailable,
    predictorFnActive: () => {
      return (
        pathname === APP_URLS.dashboard.overview.path ||
        pathname === APP_URLS.dashboard.timeline.path ||
        pathname === APP_URLS.dashboard.monitoring.path
      );
    },
    children: [
      {
        id: 'overview',
        title: t('overview'),
        to: APP_URLS.dashboard.overview.getPathWithQuery(),
        type: NavItemTypeEnum.PrimarySub,
        end: true,
        predictorFnVisible: () => isTasksAvailable,
      },
      {
        id: 'timeline',
        title: t('timeline'),
        to: APP_URLS.dashboard.timeline.getPathWithQuery(),
        type: NavItemTypeEnum.PrimarySub,
        end: true,
        predictorFnVisible: () => isTasksAvailable,
      },
      {
        id: 'monitoring',
        title: t('monitoring'),
        to: APP_URLS.dashboard.monitoring.getPathWithQuery(),
        type: NavItemTypeEnum.PrimarySub,
        end: true,
        predictorFnVisible: () => isTasksAvailable,
      },
    ],
  };
}
